const placeholder = (inputId = 'username', placeholderId = 'username-placeholder', tempClass = 'signup-temp') => {
    const $input = $('#' + inputId);
    if (!$input) return;

    const emptyInput = 'full-input';
    const $placeholder = $('#' + placeholderId);
    let inputWidth = $input.width();

    $(window).resize(() => {
        const $newInputInstance = $('#' + inputId);
        inputWidth = $newInputInstance.width();
        formatInputField($newInputInstance.val());
    });

    $input.on('input', function() {
        const $this = $(this);

        if (inputWidth < 0) {
            const $newInputInstance = $('#' + inputId);
            inputWidth = $newInputInstance.width();
        }

        if ($this.val().length) {
            if ($this.hasClass(emptyInput)) {
                $this.removeClass(emptyInput);
                const $newInputInstance = $('#' + inputId);
                inputWidth = $newInputInstance.width();
            }
        } else {
            $this.addClass(emptyInput);
        }
        formatInputField($this.val());
    });

    function formatInputField(input) {
        const textWidth = preparePlaceholderWidth(input);
        let placeholderWidth = (textWidth + 1);
        if (textWidth >= inputWidth) {
            placeholderWidth = inputWidth;
        }

        if (placeholderWidth > 1) {
            $placeholder.css({
                'margin-left': placeholderWidth + 'px',
                display: 'block',
                'max-width': 'calc(83% - ' + placeholderWidth + 'px)'
            });
        } else {
            $placeholder.removeAttr('style');
        }
    }

    function preparePlaceholderWidth(text) {
        const element = $('<span>', { class: tempClass }).appendTo(document.body);
        let elemText = element.text(text).html();
        elemText = elemText.replace(/\s/g, '&nbsp;');
        element.html(elemText);

        const width = Math.ceil(element.width());
        element.remove();

        return width;
    }
};

export default placeholder;
